import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtTL, fmtDate } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Link } from "react-router-dom";
import { AlertCircle } from "lucide-react";

export default function Upcoming() {
  const [days, setDays] = useState(30);
  const [coll, setColl] = useState([]);
  const [pays, setPays] = useState([]);

  useEffect(() => {
    api.get("/upcoming/collections", { params: { days } }).then((r) => setColl(r.data));
    api.get("/upcoming/payments", { params: { days } }).then((r) => setPays(r.data));
  }, [days]);

  const totalIn = coll.reduce((s, x) => s + x.amount, 0);
  const totalOut = pays.reduce((s, x) => s + x.amount, 0);

  return (
    <div className="space-y-6" data-testid="upcoming-page">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-3xl font-extrabold tracking-tight">Yaklaşan İşlemler</h1>
          <p className="text-sm text-muted-foreground">Vadesi yaklaşan ödemeler ve tahsilatlar</p>
        </div>
        <Select value={String(days)} onValueChange={(v) => setDays(Number(v))}>
          <SelectTrigger className="w-40"><SelectValue /></SelectTrigger>
          <SelectContent className="bg-popover">
            <SelectItem value="7">7 Gün</SelectItem><SelectItem value="30">30 Gün</SelectItem><SelectItem value="90">90 Gün</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <Card className="p-4">
          <div className="flex items-center justify-between mb-3">
            <h3 className="font-bold">Yaklaşan Tahsilatlar</h3>
            <span className="num font-semibold text-emerald-500">{fmtTL(totalIn)}</span>
          </div>
          <Table>
            <TableHeader><TableRow><TableHead>Müşteri</TableHead><TableHead>Vade</TableHead><TableHead className="text-right">Tutar</TableHead></TableRow></TableHeader>
            <TableBody>
              {coll.map((c) => (
                <TableRow key={c.id} className={c.overdue ? "bg-red-500/5" : ""}>
                  <TableCell><Link to={`/musteriler/${c.customer_id}`} className="font-medium hover:text-primary">{c.customer_name}</Link></TableCell>
                  <TableCell className={c.overdue ? "text-red-500 font-semibold" : ""}>{c.overdue && <AlertCircle size={12} className="inline mr-1" />}{fmtDate(c.due_date)}</TableCell>
                  <TableCell className="text-right num font-semibold">{fmtTL(c.amount)}</TableCell>
                </TableRow>
              ))}
              {coll.length === 0 && <TableRow><TableCell colSpan={3} className="text-center py-6 text-muted-foreground">Kayıt yok</TableCell></TableRow>}
            </TableBody>
          </Table>
        </Card>

        <Card className="p-4">
          <div className="flex items-center justify-between mb-3">
            <h3 className="font-bold">Yaklaşan Ödemeler</h3>
            <span className="num font-semibold text-primary">{fmtTL(totalOut)}</span>
          </div>
          <Table>
            <TableHeader><TableRow><TableHead>Kategori</TableHead><TableHead>Vade</TableHead><TableHead className="text-right">Tutar</TableHead></TableRow></TableHeader>
            <TableBody>
              {pays.map((p) => (
                <TableRow key={p.id} className={p.overdue ? "bg-red-500/5" : ""}>
                  <TableCell className="font-medium">{p.category}</TableCell>
                  <TableCell className={p.overdue ? "text-red-500 font-semibold" : ""}>{p.overdue && <AlertCircle size={12} className="inline mr-1" />}{fmtDate(p.due_date)}</TableCell>
                  <TableCell className="text-right num font-semibold">{fmtTL(p.amount)}</TableCell>
                </TableRow>
              ))}
              {pays.length === 0 && <TableRow><TableCell colSpan={3} className="text-center py-6 text-muted-foreground">Kayıt yok</TableCell></TableRow>}
            </TableBody>
          </Table>
        </Card>
      </div>
    </div>
  );
}
